import styles from './CoupleBtns.module.css';
import Button from '@/components/UI/Button';

interface CoupleBtnsProps {
	className?: string;
	message?: string;
	onRight: () => void;
	textRight: string;
	brightRight?: boolean;
	onLeft: () => void;
	textLeft: string;
	brightLeft?: boolean;
}

const CoupleBtns = (props: CoupleBtnsProps) => {
	return (
		<div className={styles.container}>
			<div className={styles.title}>{props.message}</div>
			<div className={styles.btns}>
				<Button
					className={`${styles.btn} ${props.className}`}
					name={props.textLeft}
					onClick={props.onLeft}
					typeSubmit={'button'}
					color={props.brightLeft ? 'white' : 'black'}
					background={props.brightLeft ? 'white' : 'black'}
				/>
				<Button
					className={`${styles.btn} ${props.className}`}
					name={props.textRight}
					onClick={props.onRight}
					typeSubmit={'button'}
					color={props.brightRight ? 'white' : 'black'}
					background={props.brightRight ? 'white' : 'black'}
				/>
			</div>
		</div>
	);
};

export default CoupleBtns;
